import { Component, Input, OnInit } from '@angular/core';
import { ChargeExceptionnelle } from '@model/syndic/charge-exceptionnelle';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { ChargeExceptionnelleService } from '@service/syndic/charge-exceptionnelle.service';
import { Globals } from '@theme/utils/globals';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ChargeExceptionnelleAddComponent } from '../charge-exceptionnelle-add/charge-exceptionnelle-add.component';

@Component({
  selector: 'app-charge-exceptionnelle-list',
  templateUrl: './charge-exceptionnelle-list.component.html',
  styleUrls: ['./charge-exceptionnelle-list.component.scss']
})
export class ChargeExceptionnelleListComponent implements OnInit {

  @Input() charges: ChargeExceptionnelle[] = [];
  @Input() houseCoUuid: string = '';
  dtOptions: any = {};

  constructor(
    private modalService: NgbModal,
    private emitter: EmitterService,
    private chargeService: ChargeExceptionnelleService
  ) {
    this.emitter.event.subscribe((data: any) => {
      if (data.action === 'CHARGE_EXCEPTIONNELLE_ADD' || data.action === 'CHARGE_EXCEPTIONNELLE_UPDATED') {
        this.loadData();
      }
    });
  }

  ngOnInit(): void {
    this.dtOptions = Globals.dataTable;
    this.loadData();
  }

  loadData(): void {
    if (this.houseCoUuid) {
      this.chargeService.getList(this.houseCoUuid).subscribe((res: any) => {
        this.charges = res || [];
      });
    }
  }

  addCharge(): void {
    this.chargeService.edit = false;
    this.chargeService.setChargeExceptionnelle(null);
    this.chargeService.houseCoUuid = this.houseCoUuid;
    const modalRef = this.modalService.open(ChargeExceptionnelleAddComponent, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.houseCoUuid = this.houseCoUuid;
  }

  editCharge(row: ChargeExceptionnelle): void {
    this.chargeService.edit = true;
    this.chargeService.setChargeExceptionnelle(row);
    const modalRef = this.modalService.open(ChargeExceptionnelleAddComponent, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.houseCoUuid = this.houseCoUuid;
  }

  deleteCharge(item: ChargeExceptionnelle): void {
    Swal.fire({
      title: 'Êtes-vous sûr ?',
      text: 'Cette action est irréversible !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Non, annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.chargeService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.status === 'success') {
            this.loadData();
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        });
      }
    });
  }
}
